export const CANCEL_CONFIRMATION_DIALOG_TITLE = 'Please confirm';
export const CANCEL_CONFIRMATION_DIALOG_CONTENT = 'Canceling will lose the changes in progress. Are you sure you want to continue?';
export const PDF_EXPORT_DISABLED_CONTENT = "PDF export is not supported for more than 100 rows.";
export const EXPORT_ERROR_TITLE = "Error!"